module.exports = __webpack_public_path__ + "static/media/hivesynth-background.7fd4d6c8.jpg";